import React from "react";

import Stack from "Cobalt/Stack";
import { Div } from "Common/HTML";
import { Card, CardSection } from "Theme/Card";

export const Skeleton = ({ className, ...rest }) => <Div className={`${className} si-skeleton`} {...rest} />;

export const TextSkeleton = ({ size = "medium", className, ...rest }) => (
  <Div className={className} {...rest}>
    <Skeleton className="h-8 w-6/12 mb-4" />
    <Skeleton className="h-4 w-full mb-2" />
    <Skeleton className="h-4 w-full mb-2" />
    <Skeleton className="h-4 w-4/12 mb-2" />
  </Div>
);

export const InputSkeleton = ({ type = "text", className, ...rest }) => {
  let inputSkeleton = null;
  if (type === "text") {
    inputSkeleton = (
      <>
        <Skeleton className="h-4 w-4/12 mb-2" />
        <Skeleton className="h-8 w-full" />
      </>
    );
  } else if (type === "radio") {
    inputSkeleton = (
      <>
        <Skeleton className="h-4 w-5/12 mb-2" />
        <Skeleton className="h-4 w-3/12 mb-2" />
        <Skeleton className="h-4 w-2/12" />
      </>
    );
  }
  return (
    <Div className={className} {...rest}>
      {inputSkeleton}
    </Div>
  );
};

export const PlanCardSkeleton = ({ className, ...rest }) => {
  return (
    <Card p={0} {...rest}>
      <CardSection>
        <Skeleton className="h-4 w-4/12" />
      </CardSection>
      <CardSection>
        <Stack direction="horizontal" justify="space-between">
          <Div className="w-8/12">
            <Stack direction="horizontal" gap="spacious">
              <Skeleton className="h-12 w-2/12" />
              <Skeleton className="h-12 w-2/12" />
              <Skeleton className="h-12 w-2/12" />
              <Skeleton className="h-12 w-2/12" />
              <Skeleton className="h-12 w-2/12" />
            </Stack>
          </Div>
          <Skeleton className="h-12 w-2/12" />
        </Stack>
      </CardSection>
      <CardSection>
        <Stack direction="horizontal" justify="space-between">
          <Skeleton className="h-4 w-3/12" />
          <Skeleton className="h-4 w-3/12" />
        </Stack>
      </CardSection>
    </Card>
  );
};
